import React from 'react';
import { Button } from '../Button/Button';

import { ArrowRightBottomIcon, Coins5, Money, MoneyPack, MoneyPack2 } from 'src/assets';
import './blueBox.scss';

export const BlueBox = (props) => {
  const {
    beforeBlackTitle,
    blackUnderlineTitle,
    whiteTitle,
    supertitle,
    subtitle,
    onClick,
    buttonTitle,
    images = 'default',
  } = props;

  return (
    <div className="blue-box">
      <div className="blue-box-wrapper">
        <div className="blue-box-wrapper-content">
          <div className="blue-box-background" />
          <img
            src={images === 'default' ? MoneyPack : MoneyPack2}
            alt={images === 'default' ? MoneyPack : MoneyPack2}
            className="blue-box-image-1"
          />
          <img src={Money} alt={Money} className="blue-box-image-2" />
          <img src={Coins5} alt={Coins5} className="blue-box-image-3" />
        </div>
      </div>
      <div className="blue-box-content">
        <supertitle className="blue-box-supertitle">{supertitle}</supertitle>
        <h1 className="blue-box-title">
          {beforeBlackTitle ? beforeBlackTitle : ''}{' '}
          <black-underline>{blackUnderlineTitle}</black-underline> {whiteTitle}
        </h1>
        <div className="blue-box-subtitle">{subtitle}</div>
      </div>
      <div className="blue-box-button">
        <Button onClick={onClick} title={buttonTitle} icon={ArrowRightBottomIcon} color="white" />
      </div>
    </div>
  );
};
